import Axios from 'axios';
import { SingleProductOrder } from '../models';

export const createTestCloudQuote = async (data: Required<Pick<SingleProductOrder, 'organizationId' | 'planId' | 'number'>> & Partial<Pick<SingleProductOrder, 'discountCode'>>) => (await Axios.post('v1/quotes', data)).data;
